const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;
export const TOKEN_KEY = "vendamarket.token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const isForm = options.body instanceof FormData;
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      ...(isForm ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || "Something went wrong";
    const err = new Error(typeof msg === "string" ? msg : "Request failed");
    err.status = res.status;
    throw err;
  }
  return data;
}

// Resolve a stored image path to an absolute URL usable in <img src>.
export function resolveImage(url) {
  if (!url) return undefined;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/")) return `${BASE}${url}`;
  return `${BASE}/api/files/${url}`;
}

// Upload an image File (from <input type=file>) to the public bucket.
export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await apiFetch("/upload", { method: "POST", body: form });
  return res.url; // /api/files/...
}

// Upload a private KYC document; returns the /api/files/{path} url for verification submit.
export async function uploadIdDocument(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await apiFetch("/upload-id", { method: "POST", body: form });
  return `/api/files/${res.path}`;
}
